import { useEffect, useState, RefObject } from "react";

/* Uses the ref to calculate the remaining height of the viewport and sets it as the height of the element */
const useDynamicHeight = (ref: RefObject<HTMLElement>): string => {
    const [height, setHeight] = useState<string>("auto");

    useEffect(() => {
        const calculateHeight = () => {
            if (ref.current) {
                let offsetHeight = 0;

                // Traverse preceding siblings and calculate their height
                let element = ref.current.previousElementSibling as HTMLElement | null;
                while (element) {
                    const style = window.getComputedStyle(element);
                    // Exclude sticky or fixed elements
                    if (style.position !== "sticky" && style.position !== "fixed") {
                        offsetHeight += element.offsetHeight;
                    }
                    element = element.previousElementSibling as HTMLElement | null;
                }

                // Calculate remaining height: viewport height minus offset height
                const remainingHeight = window.innerHeight - offsetHeight;
                setHeight(`${remainingHeight}px`);
            }
        };

        calculateHeight(); // Calculate on initial render
        window.addEventListener("resize", calculateHeight);

        return () => window.removeEventListener("resize", calculateHeight);
    }, [ref]);

    return height;
};

export default useDynamicHeight;
